// Display grouping for the city selector. JS-only metadata: the
// engine's authoritative city table lives in telugu_panchangam/cities.py.

export const CITY_GROUPS: Array<[string, string[]]> = [
  ['Telugu Heartland', ['Hyderabad', 'Vijayawada', 'Visakhapatnam', 'Tirupati', 'Warangal', 'Guntur', 'Nizamabad', 'Rajahmundry', 'Kurnool', 'Nellore']],
  ['Major Indian Metros', ['Bengaluru', 'Chennai', 'Mumbai', 'Delhi']],
  ['International', ['Dallas', 'San Jose', 'San Francisco', 'Edison', 'New York', 'London', 'Sydney', 'Dubai']],
];
